module.exports = __webpack_public_path__ + "img/vcontroller-show-dimming1.6a5e189a.png";